;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/form/:formId/thank-you\",\"regex\":\"^/form/([^/]+)/thank-you$\",\"paramNames\":[\"formId\"]},{\"path\":\"/form/:formId\",\"regex\":\"^/form/([^/]+)$\",\"paramNames\":[\"formId\"]},{\"path\":\"/form/:formId/second-step\",\"regex\":\"^/form/([^/]+)/second-step$\",\"paramNames\":[\"formId\"]},{\"path\":\"/preview/:formId\",\"regex\":\"^/preview/([^/]+)$\",\"paramNames\":[\"formId\"]},{\"path\":\"/preview/:formId/second-step\",\"regex\":\"^/preview/([^/]+)/second-step$\",\"paramNames\":[\"formId\"]}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/form/closed\"}]}";globalThis["_sentryNextJsVersion"] = "16.2.9";import * as Sentry from "@sentry/nextjs";

const startSentry =
    process.env.NEXT_PUBLIC_APP_ENVIRONMENT === "production" ||
    process.env.NEXT_PUBLIC_APP_ENVIRONMENT === "test" ||
    process.env.NEXT_PUBLIC_APP_ENVIRONMENT === "beta";

if (startSentry) {
    Sentry.init({
        dsn: "https://d322c7c212643095fe3c73a3daec84e8@o404438.ingest.us.sentry.io/4507214198603776",
        // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
        sendDefaultPii: true,
        environment: process.env.NEXT_PUBLIC_APP_ENVIRONMENT || process.env.NODE_ENV,
        tracesSampleRate: 0,
        debug: false,
        integrations: [Sentry.extraErrorDataIntegration()],
        replaysOnErrorSampleRate: 1.0,
        replaysSessionSampleRate: 0.1,
        ignoreErrors: [
            "NotFoundError: Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.",
            "undefined is not an object (evaluating 't.Domain')",
            "undefined is not an object (evaluating 'r.DomainData')",
            "Window.getComputedStyle: Argument 1 is not an object.",
            "Failed to get form",
        ],
    });
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
